/**
 * Filters an array of items by a search term using a text accessor.
 * Normalization (trim + lowercase) is applied internally.
 * Items whose accessor returns a falsy value are excluded when a term is active.
 *
 * @param {Array} items - Array to filter
 * @param {Function} getSearchableText - Accessor returning the searchable string for an item
 * @param {string|null} term - Search term (null / empty → all items returned unchanged)
 * @returns {Array} Filtered array
 */
export function filterBySearchTerm(items, getSearchableText, term) {
  if (!term || !term.trim()) return items;
  const normalized = term.toLowerCase().trim();
  return items.filter(item => {
    const text = getSearchableText(item);
    return text ? text.toLowerCase().includes(normalized) : false;
  });
}
